import { Flex, Radio, RadioGroup } from "@chakra-ui/react";
import { convertTextAlignToFlex } from "components/containers/InspectionFormat/Content/SettingFontSize/utils/style";
import { transformCheckboxExtraKey } from "models/pinFrame";
import { Fragment, memo, useMemo } from "react";
import { InputRaw } from "../../input";
import { FieldRawProps } from "../../types";

const CheckboxRaw = (props: FieldRawProps) => {
  const {
    containerRef,
    item,
    linkedData,
    style: pinComponentStyle,
    ...boxProps
  } = props;

  const additionInfoCheckbox = Object.values(
    item?.additionInfo?.checkbox?.mapValues || {}
  );
  const { isCheckboxValue, isCheckboxLabel, extraId } =
    transformCheckboxExtraKey(linkedData?.extraId);

  const textAlign = pinComponentStyle?.textAlign;
  const alignItems = useMemo(
    () => convertTextAlignToFlex(textAlign),
    [textAlign]
  );

  if (isCheckboxLabel) {
    return <InputRaw {...props} />;
  }

  if (isNaN(Number(extraId))) {
    return <></>;
  }

  return (
    <RadioGroup
      display="flex"
      alignItems={pinComponentStyle.alignItems || "center"}
      justifyContent={pinComponentStyle?.textAlign || "left"}
      {...(boxProps as any)}
      height="100%"
      sx={{
        ".chakra-radio__control": {
          borderRadius: 0,
          position: "relative",
          borderColor: "#A3A3A3",
          width: `${pinComponentStyle.fontSize}px`,
          height: `${pinComponentStyle.fontSize}px`,
          "&[data-checked]": {
            borderColor: "transparent",
            "&:before": {
              position: "absolute",
              left: 0,
              top: 0,
              content: "'\\2705'",
              backgroundColor: "transparent",
              width: "100%",
              height: "100%",
              fontSize: `${pinComponentStyle.fontSize}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          },
        },
        ".chakra-radio__label": {
          ...pinComponentStyle,
          whiteSpace: "nowrap",
          width: `calc(100% - ${pinComponentStyle.fontSize}px)`,
          fontSize: `${pinComponentStyle.fontSize}px`,
        },
      }}
    >
      <Flex
        width="100%"
        flexDirection="column"
        gap="1rem"
        alignItems={alignItems}
      >
        {additionInfoCheckbox.map((data: any, index) => {
          if (index.toString() !== extraId) {
            return <Fragment key={index} />;
          }

          return (
            <Radio
              isReadOnly={true}
              width="fit-content"
              maxWidth="100%"
              key={index}
              value={String(index)}
            >
              {!isCheckboxValue && data.displayValue}
            </Radio>
          );
        })}
      </Flex>
    </RadioGroup>
  );
};

export default memo(CheckboxRaw);
